import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import JwtService from "@/core/services/jwt.service";
import ApiInterceptorService from "@/core/services/auth_interceptor.api.service";

/**
 * @link https://cli.vuejs.org/guide/mode-and-env.html#using-env-variables-in-client-side-code
 * Service to call HTTP request via Axios
 */
const ApiService = {
  /**
   * Init the API Service with Vue Axios and Axios.
   */
  init() {
    Vue.use(VueAxios, axios);
    console.log("BASE URL" + process.env.VUE_APP_API_URL);
    axios.defaults.baseURL = process.env.VUE_APP_API_URL;

    this.setInterceptors();
  },

  /**
   * Set authentication and other interceptors
   *
   * @link https://axios-http.com/docs/handling_errors
   */
  setInterceptors() {
    ApiInterceptorService.create();
  },

  /**
   * Set the default HTTP request headers
   */
  setHeader() {
    Vue.axios.defaults.headers.common[
      "Authorization"
    ] = `Bearer ${JwtService.getToken()}`;
  },

  /**
   * Get request but better. Use this one instead of get!
   *
   * @param resource
   * @param params
   * @returns {Promise<AxiosResponse<any>>}
   */
  query(resource, params) {
    return Vue.axios.get(resource, params).catch((error) => {
      // console.log(error);
      throw new Error(`[KT] ApiService ${error}`);
    });
  },

  /**
   * Send the GET HTTP request
   * @param resource
   * @param slug
   * @returns {*}
   */
  get(resource, slug = "") {
    return Vue.axios.get(`${resource}/${slug}`).catch((error) => {
      // console.log(error);
      throw new Error(`[KT] ApiService ${error}`);
    });
  },

  /**
   * Set the POST HTTP request
   * @param resource
   * @param params
   * @returns {*}
   */
  post(resource, params, config) {
    return axios.post(resource, params, config);
  },

  /**
   * Send the UPDATE HTTP request
   * @param resource
   * @param slug
   * @param params
   * @returns {IDBRequest<IDBValidKey> | Promise<void>}
   */
  update(resource, slug, params) {
    return Vue.axios.put(`${resource}/${slug}`, params);
  },

  /**
   * Send the PUT HTTP request
   * @param resource
   * @param params
   * @returns {IDBRequest<IDBValidKey> | Promise<void>}
   */
  put(resource, params) {
    return Vue.axios.put(`${resource}`, params);
  },

  /**
   * Send the DELETE HTTP request
   * @param resource
   * @param params
   * @returns {*}
   * @link https://masteringjs.io/tutorials/axios/delete
   */
  delete(resource, params) {
    return Vue.axios.delete(resource, params).catch((error) => {
      // console.log(error);
      throw new Error(`[RWV] ApiService ${error}`);
    });
  },
};

export default ApiService;
